import { render } from "./FormFormRight.vue?vue&type=template&id=3bac0d5a"
import script from "./FormFormRight.vue?vue&type=script&lang=js"
export * from "./FormFormRight.vue?vue&type=script&lang=js"

import "./FormFormRight.vue?vue&type=style&index=0&id=3bac0d5a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__